const secondary = {
    social_bind_with: '이미 계정이 있으신가요? {{methods, list(type: disjunction;)}}로 로그인 해보세요!',
};
export default Object.freeze(secondary);
